/**
 * How many leads are waiting to be claimed, shared between the alerts (which
 * ask the server) and the badges (which only show the number).
 *
 * One request feeds every badge: the alert component publishes what it
 * learned here, and the tab badge and the sidebar badge read it. Nothing
 * that shows the number asks the server for it.
 */
import { useEffect, useState } from "react";

let count = null; // null = not known yet
const listeners = new Set();

export function publishNewLeadCount(next) {
  const n = Number.isFinite(next) ? next : null;
  if (n === count) return;
  count = n;
  listeners.forEach((fn) => fn(count));
}

export function useNewLeadCount() {
  const [value, setValue] = useState(count);
  useEffect(() => {
    listeners.add(setValue);
    setValue(count);
    return () => { listeners.delete(setValue); };
  }, []);
  return value;
}
